"use client";

import React from "react";
import logo from "@/assets/images/logos/brand/logo.webp";
import Image from "next/image";
import { data } from "@/data";
import { Smoothup } from "@/components/common/animations";

export default function Footer() {
  const handleNavigation = (href: string) => {
    // Check if it's a hash link (starts with #) or a regular URL
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    } else {
      // Regular URL - navigate normally
      window.location.href = href;
    }
  };

  return (
    <Smoothup className="overflow-hidden mx-auto max-w-6xl flex-col align-center justify-center py-8 px-5 xl:px-0">
      <div className="flex flex-col items-center  lg:flex-row lg:items-start space-y-10 lg:space-y-0 lg:space-x-10">
        {/* ---------Logo--------- */}
        <div className="flex flex-col items-center  lg:items-start space-y-5">
          <Image
            alt="logo"
            className="h-[2rem] w-[7.6rem] "
            src={logo}
          />
          <span className="text-center lg:text-start font-normal text-black text-sm">
            {data.footer.disclaimer}
          </span>
        </div>
        <div className="flex flex-row text-center lg:text-start space-x-10">
          {/* ---------Links--------- */}
          <div>
            <ul className="flex flex-col space-y-3 min-w-[130px]">
              {data.footer.list.map((link, index) => (
                <li key={link.name} className="group relative">
                  <button
                    key={index}
                    onClick={() => handleNavigation(link.href)}
                    className="inline-flex items-center gap-1.5"
                  >
                    {link.name}
                    {link.name === "Families" && (
                      <span className="text-[9px] font-medium text-black/40">beta</span>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          {/* ---------Contact--------- */}
          <div>
            <ul className="flex flex-col space-y-3">
              <li>Contact</li>
              <li>
                <a className="footer-desc" href="mailto:info@usecove.com">
                  info@usecove.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* ----------------Socials---------------- */}
        <div className="flex flex-row items-center justify-center space-x-3">
          {data.socialData.map((icon, index) => (
            <a
              key={index}
              href={icon.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Visit our ${icon.name} page`}
              className="social-icons inline-block"
            >
              <icon.Icon aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>
      {/* ----------Copyright---------- */}
      <hr className="mt-10 mb-10 border-t border-bgBlack/10" />
      <div className="flex flex-col space-y-5 lg:space-y-0 lg:flex-row items-center justify-between">
        {" "}
        <span className="footer-desc text-center md:text-start">
          Copyright © 2023 Eden Financial Technologies Incorporated DBA Cove
        </span>
        <div className="flex flex-col space-y-5 md:space-y-0 md:flex-row items-center lg:space-x-8">
          {data.footer.links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noreferrer"
              className="text-center footer-desc transition duration-300 ease-in-out cursor-pointer"
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </Smoothup>
  );
}